// React.
import React from 'react';

// Material UI.
import Paper from '@material-ui/core/Paper';

// Components.
import FeaturedBoxSettings from '../settings/FeaturedBoxSettings';

// Styles.
import useStyles from './SettingsStyles';

const FeaturedBoxSettingsPage = () => {
  const classes = useStyles();

  return (
    <Paper className={ classes.paper } elevation={3} square={false} variant="elevation">
      <FeaturedBoxSettings/>
    </Paper>
  )
}

export default FeaturedBoxSettingsPage;
